import moment from 'moment-timezone'

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    ss: '%s sec',
    m: 'a minute',
    mm: '%d min',
    h: 'an hour',
    hh: '%dh',
    d: 'a day',
    dd: '%dd',
    M: 'a month',
    MM: '%dM',
    y: 'a year',
    yy: '%dY'
  }
})

export const relativeTime = function (raceTime: string, relativeTo: null | Date = null): string {
  let timeRelativeTo = new Date()
  if (relativeTo !== null) {
    timeRelativeTo = relativeTo
  }

  const start = moment.tz(raceTime, 'Australia/Sydney')
  const end = moment(timeRelativeTo)

  return start.from(end)
}
